{
  "account": {
    "backoffice": "Haldusliides",
    "changeEmail": "Vaheta email",
    "changePassword": "Vaheta salasõna",
    "confirmNewPassword": "Kinnita uus salasõna",
    "currentPassword": "Praegune salasõna",
    "deliveryMethods": "Kohaletoimetamise viisid",
    "deliveryMethodsDesc": "Kuidas soovite teavitusi saada?",
    "email": "E-post",
    "emailCannotBeEmpty": "Email ei saa olla tühi",
    "failedToLoadSettings": "Teavitussätete laadimine ebaõnnestus",
    "language": "Keel",
    "maintenanceReminders": "Hooldusmeeldetuletused",
    "maintenanceRemindersDesc": "Saate teavituse eelolevate hooldustööde kohta",
    "mobileApp": "Mobiilirakendus",
    "myConnections": "Minu seosed",
    "newEmail": "Uus email",
    "newPassword": "Uus salasõna",
    "notificationPreferences": "Teavitussätted",
    "notificationSettingsError": "Teavitussätete salvestamine ebaõnnestus",
    "notificationSettingsSaved": "Teavitussätted salvestatud",
    "notificationTypes": "Teavituste tüübid",
    "passwordsNotSame": "Uus salasõna ja kinnitus ei ole võrdsed",
    "successfulEmailChange": "Emaili vahetamise kinnituseks kontrollige oma postkasti",
    "successfulPasswordChange": "Salasõna vahetamine õnnestus",
    "warrantyMessages": "Uued garantiisõnumid",
    "warrantyMessagesDesc": "Garantiiteenuse pakkuja vastuste teavitused"
  },
  "analytics": {
    "askQuestion": "Küsi oma andmete kohta...",
    "clearChat": "Tühjenda vestlus",
    "loadingSavedChat": "Laadin salvestatud vestlust...",
    "stop": "Peata",
    "title": "Analüütika",
    "tryAsking": "Proovi küsida:"
  },
  "building": {
    "analytics": "Analüütika",
    "customWarrantyNotificationEmailTemplate": "Kohandatud garantiiteavituse e-kirja mall",
    "exposeSubmitterEmailInHausing": "Näita esitaja e-posti Hausingus",
    "fileUploadMandatory": "Faili üleslaadimine kohustuslik",
    "frontendFeatureFlags": "Kasutajaliidese funktsioonide lipud",
    "hausingBuildingId": "Hausing hoone ID",
    "hausingClientId": "Hausing kliendi ID",
    "hausingClientSecret": "Hausing kliendi salavõti",
    "hausingCompanyId": "Hausing ettevõtte ID",
    "hausingMessageSyncDisabled": "Hausingu sõnumite sünkroonimine on välja lülitatud",
    "hausingOptOut": "Hausing loobumine (jäta Hausingu nõue selle hoone jaoks vahele)",
    "hausingSyncDisabled": "Hausingu sünkroonimine keelatud",
    "hausingTicketDescription": "Hausingu pileti kirjeldus",
    "hausingTicketTitle": "Hausingu pileti pealkiri",
    "householdImagesPattern": "Korteri piltide muster",
    "lookerReport": "Lookeri raport",
    "lookerReportLink": "Looker raporti link",
    "options": "Valikud",
    "propertyManagerCaseRules": "Halduri juhtumi reeglid",
    "questionsPrompt": "Küsimuste viip",
    "settings": "Maja seaded",
    "voiceWarrantyPrompt": "Häälgarantii juhis",
    "warrantyAutoReplyMessage": "Garantii automaatvastuse sõnum",
    "warrantyDisabledMessage": "Teade kui garantiiesitamine on keelatud",
    "warrantyEmailUserList": "Garantii e-kirja kasutajate nimekiri",
    "warrantyRules": "Garantii reeglid",
    "warrantySyncEmail": "Garantii sünkroonimise e-post",
    "welcomeEmail": "Uute kasutajate tervitusmeil"
  },
  "buildingSettings": {
    "accesses": "Hoone administraatorid",
    "addNewAccess": "Lisa uus hoone administraator",
    "ai": {
      "saveError": "AI seadistuse salvestamine ebaõnnestus",
      "saveSuccess": "AI seadistus edukalt salvestatud"
    },
    "aiSettings": "AI seadistus",
    "analyticsSettings": "Analüütika",
    "chatPresetQuestions": "Vestluse eelvalmistatud küsimused",
    "emailForwarding": "Küsimuste edastamine",
    "employeeSettings": "DoBu töötaja seaded",
    "enableInternalAnalytics": "Luba sisemine analüütika",
    "fieldSaveError": "Salvestamine ebaõnnestus",
    "hausing": {
      "clientSecretNotStored": "Salajast võtit pole salvestatud. Sisesta see enne ühenduse lubamist.",
      "clientSecretReplace": "Sisesta uus salajane võti, et salvestatud võti asendada",
      "clientSecretRequired": "Sisesta Hausingu kliendi salajane võti",
      "clientSecretStored": "Salajane võti on salvestatud. Jäta väli tühjaks, et seda mitte muuta.",
      "connectionConfigured": "Hausingu ühendus on seadistatud.",
      "connectionNotConfigured": "Hausingu ühendus pole seadistatud.",
      "loadError": "Hausingu seadete laadimine ebaõnnestus",
      "noFlats": "Kortereid pole.",
      "noRoom": "Hausingu ruum puudub",
      "roomMappings": "Korterite sidumine ruumidega",
      "roomMappingsHelp": "Seo iga DoBu korter selle Hausingu ruumiga.",
      "roomMappingsUnavailable": "Salvesta enne korterite sidumist Hausingu ühendus.",
      "roomSaveError": "Korteri ja ruumi seose salvestamine ebaõnnestus",
      "roomsLoadError": "Hausingu ruumide laadimine ebaõnnestus. Kontrolli ühenduse seadeid.",
      "roomsLoading": "Laadin Hausingu ruume...",
      "saveError": "Hausingu sätete salvestamine ebaõnnestus",
      "saveSuccess": "Hausingu sätted edukalt salvestatud"
    },
    "hausingSettings": "Hausing",
    "homeownersDashboard": {
      "accountCount": "({{count}} kontot kokku)",
      "actions": "Toimingud",
      "apartment": "Korter",
      "close": "Sulge",
      "confirmRemove": "Eemalda",
      "confirmRemoveMessage": "Kas eemaldada {{name}} korterist {{apartment}}?",
      "confirmRemoveTitle": "Eemalda omanik",
      "homeowners": "Koduomanikud",
      "individual": "Eraisik",
      "loadError": "Korterite omanikke ei õnnestunud laadida.",
      "manage": "Halda",
      "noHomeowners": "Omanikke pole määratud",
      "noResults": "Sobivaid kortereid ei leitud",
      "organization": "Ettevõte",
      "passwordResetEmailFailed": "Parooli lähtestamise e-kirja saatmine ebaõnnestus. Palun proovi uuesti.",
      "passwordResetEmailSent": "Parooli lähtestamise e-kiri saadeti aadressile {{email}}.",
      "removeError": "Omaniku eemaldamine ebaõnnestus. Palun proovi uuesti.",
      "removeOwner": "Eemalda",
      "removeOwnerLabel": "Eemalda {{name}} korterist {{apartment}}",
      "resetPassword": "Lähtesta parool",
      "searchPlaceholder": "Otsi kortereid või omanikke",
      "sendPasswordResetEmailLabel": "Saada parooli lähtestamise e-kiri aadressile {{email}}",
      "summary": "{{householdsWithOwners}} / {{householdsCount}} korteril on omanikud määratud",
      "title": "Korterite omanikud"
    },
    "householdSettings": "Korterite seaded",
    "lookerReportLink": "Lookeri raporti link",
    "questionsForwarding": {
      "addRule": "Lisa reegel",
      "allowForwarding": "Luba küsimuste edastamine?",
      "description": "Kirjeldage probleeme, mis tuleks sellele isikule edastada...",
      "descriptionPlaceholder": "nt Torustiku probleemid, Elektririkked",
      "email": "E-post",
      "emailInvalid": "Kasutajat ei leitud või ta pole selle hoone administraator.",
      "emailPlaceholder": "kasutaja@example.com",
      "name": "Reegli nimi",
      "namePlaceholder": "nt Tehnilised küsimused",
      "removeRule": "Eemalda reegel",
      "saveSuccess": "Seaded edukalt salvestatud",
      "title": "Koduomanike küsimuste edastamine"
    },
    "structuredWarrantySettings": "Täiustatud garantiivoog",
    "tallyForms": "Tally vormid",
    "title": "Maja seaded",
    "viewAnalytics": "Vaata analüütikat",
    "viewLookerReport": "Kasutuse statistika",
    "warranty": {
      "saveError": "Osa garantiiseadeid jäi salvestamata",
      "saveSuccess": "Garantii sätted edukalt salvestatud"
    },
    "warrantySettings": "Garantii"
  },
  "case": {
    "addReplyPromptBody": "Lisa vastus vestluse jätkamiseks. Juhtum jääb suletuks.",
    "addReplyPromptTitle": "Lisa vastus",
    "awaitingReply": "Ootab vastust",
    "closeFollowUp": "Vastust pole vaja",
    "closedByService": "Juhtum on järelteeninduse poolt suletud",
    "closedCantMessage": "See juhtum on suletud.",
    "closedFollowUpBanner": "Elanik kirjutas pärast juhtumi sulgemist. Vasta või märgi, et vastust pole vaja. Juhtum jääb mõlemal juhul suletuks.",
    "completedCases": "Suletud",
    "markedAsSolved": "Juhtum on märgitud lahendatuks",
    "messageWithImage": "Sõnum pildiga",
    "noCases": "Teil ei ole ühtegi juhtumit",
    "notFound": "Juhtumit ei leitud",
    "ongoingCases": "Pooleliolevad",
    "previousChatWithBot": "Eelnev vestlus juturobotiga",
    "reopenPromptBody": "Taasava juhtum, et jätkata vestlust järelteenindusega. Uut juhtumit pole vaja luua.",
    "reopenPromptTitle": "Probleem ikka veel lahendamata?",
    "replyWillReopen": "Sõnumi saatmine taasavab selle juhtumi.",
    "replyWillStayClosed": "Sõnumi saatmine teavitab järelteenindust. Juhtum jääb suletuks.",
    "submittedCases": "Esitatud juhtumid"
  },
  "casePage": {
    "backHome": "Tagasi avalehele",
    "notFound": "Seda juhtumit ei õnnestunud avada. Link võib olla vale või puudub sul ligipääs."
  },
  "chat": {
    "videoAttachment": "Videomanus",
    "askFailed": "Vastust ei õnnestunud saada. Kontrolli ühendust ja proovi uuesti.",
    "tryAgain": "Proovi uuesti",
    "enterQuestion": "Sisesta küsimus",
    "escalateNo": "Ei",
    "escalateNoReply": "Selge, ma ei edasta küsimust. Küsi julgelt muud oma kodu kohta.",
    "escalateYes": "Jah",
    "escalationForm": {
      "back": "Tagasi",
      "backToForm": "Tagasi vormi juurde",
      "recipient": "Saaja",
      "send": "Saada",
      "sendErrorMessage": "Sõnumi saatmisel tekkis viga. Palun proovige uuesti.",
      "sendSuccessMessage": "Teie sõnum on edukalt saadetud.",
      "sending": "Saadan...",
      "summary": "Sinu probleemi kokkuvõte",
      "summaryEditable": "Saad seda kokkuvõtet enne saatmist muuta.",
      "title": "Pealkiri"
    },
    "escalationFailed": "Küsimust ei õnnestunud edasi saata. Proovi uuesti.",
    "escalationInProgress": "Analüüsime teie päringut, et ühendada teid õige eksperdiga. See võib võtta hetke...",
    "longConversationWarning": "AI mõistus võib pikkades vestlustes halveneda. Kaaluge uue vestluse alustamist, kui teie teema on muutunud.",
    "pin1": "Uks kriuksub",
    "pin2": "Mis on minu seinavärv?",
    "pin3": "Kuidas ma termostaati kasutan?",
    "question1": "Millega ma seina võiksin puhastada?",
    "question2": "Uks kriuksub",
    "question3": "Vannitoa trapist tuleb halb hais",
    "question4": "Millised plaadid on minu esikus?",
    "searchingDocuments": "Otsin vastust sinu kodu dokumentidest",
    "send": "Saada",
    "talkToYourHome": "Räägi oma koduga",
    "warrantyCta": {
      "primary": "Esita garantiijuhtum",
      "supporting": "See paistab olevat garantiijuhtum. Jätka garantiivoos."
    }
  },
  "chatPresetSettings": {
    "addPreset": "Lisa keele eelvalik",
    "enable": "Luba kohandatud vestluse eelvalikud",
    "errors": {
      "invalidLanguage": "Keel peab olema kahetäheline kood (nt 'en')",
      "noQuestions": "Iga keele eelvalikul peab olema vähemalt üks küsimus"
    },
    "language": "Keel ISO 639-1 (nt en et lv)",
    "questionPlaceholder": "Küsimus {{number}}",
    "questions": "Eelvalmistatud küsimused",
    "removePreset": "Eemalda eelvalik",
    "success": {
      "saved": "Vestluse eelvalikute seaded edukalt salvestatud"
    }
  },
  "common": {
    "cancel": "Tühista",
    "error": {
      "400": "Osa andmetest ei sobi. Kontrolli ja proovi uuesti.",
      "401": "Sessioon on lõppenud. Palun logi uuesti sisse.",
      "403": "Sul puudub selleks õigus.",
      "404": "Otsitavat ei leitud. See võib olla eemaldatud.",
      "409": "See läheb vastuollu olemasolevate andmetega. Värskenda lehte ja proovi uuesti.",
      "413": "Fail on liiga suur.",
      "500": "Midagi läks valesti. Palun proovi varsti uuesti.",
      "loading": "Lehe laadimine ebaõnnestus. Palun värskenda lehte.",
      "network": "Ühendus puudub. Kontrolli internetiühendust ja proovi uuesti."
    },
    "intervalDays": "{{count}} päeva",
    "loading": "Laadin...",
    "loadingData": "Laadimine...",
    "returnToHome": "Tagasi avalehele",
    "saveChanges": "Muudatuste salvestamine",
    "saving": "Salvestamine...",
    "tryAgain": "Proovi uuesti",
    "validating": "Kontrollin..."
  },
  "files": {
    "addFiles": "Lisa dokumendid",
    "addFilesInstructions": "<span1>Lohistage</span1> dokumendid siia, või <span2>vajutage</span2>, et valida käsitsi",
    "confirmDeleteBody": "Kas te olete kindel et tahate seda dokumendi kustutada?",
    "confirmDeleteNo": "Mine tagasi",
    "confirmDeleteTitle": "Kustuta dokument",
    "confirmDeleteYes": "Kustuta",
    "download": "Laadi alla",
    "loadingPreview": "Dokumendi avamine...",
    "officePreviewHint": "Dokumenti ei kuvata?",
    "openInNewTab": "Ava uuel vahelehel",
    "previewError": {
      "message": "Me ei saanud selle dokumendi eelvaadet kuvada. Fail on endiselt kättesaadav ja seda saab avada teie eelistatud rakenduses.",
      "title": "Eelvaade pole saadaval"
    },
    "remove": "Kustuta",
    "save": "Salvesta",
    "stillLoading": "Laadimine võtab aega. Suure faili avamine võib kesta kuni minuti.",
    "successfullyUploaded": "Failid edukalt üles laetud",
    "uploading": "Laen faile üles..."
  },
  "home": {
    "myResidences": "Minu elukohad",
    "welcome": "Tere tulemast"
  },
  "household": {
    "actions": "AI Otsing",
    "documents": "Dokumendid",
    "exterior": "Väliala",
    "floor": "korrus",
    "maintenanceActivities": "Minu hooldustegevused",
    "maintenanceInfo": "Kõik vajalikud hooldused mida koduomanik peab teostama on kirjas vastavates juhendites.",
    "mobileApp": {
      "appLink": "Lae alla siit.",
      "message": "DoBu tuli välja mobiiliäpiga:"
    },
    "products": "toodet",
    "productsWithoutRoom": "Ruumideta tooted",
    "propertyManagerCases": "Vaata halduri juhtumeid",
    "roomsAndProducts": "Ruumid ja tooted",
    "warrantyCases": "Vaata garantiijuhtumeid"
  },
  "loggedInPage": {
    "tallyFormBanner": {
      "button": "Täida Vorm"
    }
  },
  "login": {
    "aboutInfo": "DoBu on hetkel avatud ainult meid kasutavate kinnisvaraarenduste koduomanikele.",
    "alreadyHaveAccount": "Juba omad <strong>DoBu</strong> kontot?",
    "confirm": "Kinnita",
    "confirmEmailChange": "Kinnitage emaili vahetus",
    "confirmNewPassword": "Kinnita uus salasõna",
    "confirmPassword": "Kinnita salasõna",
    "continue": "Jätka",
    "email": "E-post",
    "emailChangeSuccessful": "Emaili vahetamine õnnestus, uus email on {{newEmail}}. Palun logige sisse kasutades uut emaili",
    "error": {
      "invalidOldPassword": "Vale vana salasõna",
      "notAuthorized": "Õigus vahetamiseks puudub",
      "privateRelayNotAllowed": "Sisselogimine Apple ei ole võimalik, kui vajutada \"hide my email\".Palun logige sisse läbi teise kanali või kustutadge Apple ID sätetest oma DoBu konto ning proovige uuesti.",
      "socialUserNotRegistered": "Sinu Google/Apple konto email ei ole DoBu kontoga seotud. Kontrolli millisele emailile DoBu poolt parooli loomise email saadeti.",
      "tokenExpired": "Link on kas kasutatud või aegunud.",
      "userNotFound": "Kontot ei leitud. See on hallatav rakendus. Konto seadistamiseks võtke ühendust oma hoone administraatoriga."
    },
    "forgotPassword": "Unustasid parooli?",
    "login": "Logi sisse",
    "loginError": "Kasutajat ei leitud, või salasõna on vale",
    "logout": "Logi välja",
    "newEmail": "Uus email",
    "newPassword": "Uus salasõna",
    "noAccount": "Pole <strong>DoBu</strong> kontot?",
    "noAccountHeader": "Pole DoBu kontot?",
    "noAccountYet": "Pole veel kontot? Arendaja või haldur peab sind esmalt DoBus sinu kodu juurde lisama. Seejärel saad e-kirja parooli loomiseks.",
    "or": "või",
    "password": "Parool",
    "passwordResetInstructions": "Sisesta oma DoBu konto e-post ja saadame sulle lingi uue parooli määramiseks.",
    "privacyPolicy": "Privaatsuspoliitika",
    "recoveryFormNotValid": "Taastevorm ei ole kehtiv",
    "resetPassword": "Saada link",
    "resetPasswordFormSuccess": "Kui selle e-postiga on DoBu konto, saatsime sinna lingi uue parooli määramiseks. Vaata ka rämpsposti kausta.",
    "stuckHelp": "Ei saa sisse? Kasuta e-posti aadressi, kuhu DoBu sulle esimese kirja saatis, või kirjuta meile: <mail>info@dobu.app</mail>.",
    "resetPasswordSuccess": "Salasõna uuendatud, saate nüüd sisse logida uue salasõnaga",
    "seeMore": "Vaata rohkem",
    "wantToTry": "Kui sul on ikka huvi DoBu proovida, võid meile kirjutada:"
  },
  "notifications": {
    "alreadyUnsubscribed": "Tellimus oli juba lõpetatud {{date}}",
    "confirmUnsubscribe": "Kinnita loobumine",
    "confirmUnsubscribeMessage": "Kas oled kindel, et soovid teavitustest loobuda? Sa saad need alati oma konto seadetes uuesti aktiveerida.",
    "invalidUnsubscribeToken": "Kehtetu või aegunud tellimuse lõpetamise link",
    "unsubscribeConfirm": "Jah, loobu teavitustest",
    "unsubscribeDescription": "Oled loobumas kõikidest teavitustest.",
    "unsubscribeErrorGeneric": "Tellimuse lõpetamisel ilmnes tõrge",
    "unsubscribeSuccess": "Tellimus edukalt lõpetatud",
    "unsubscribeSuccessDetail": "Te ei saa meilt enam teavitusi.",
    "unsubscribeTitle": "Teavitustest loobumine",
    "unsubscribing": "Teatiste tellimuse lõpetamine..."
  },
  "product": {
    "addDocuments": "Lisa dokumendid",
    "addNewProduct": "Lisa uus toode",
    "addProduct": "Lisa toode",
    "addProductFiles": "Lisa failid",
    "change": "Muuda",
    "changeProduct": "Muuda toodet",
    "confirmMaintenanceDone": "Hooldus tehtud",
    "delete": "Kustuta",
    "everyNumberOfDays": "Iga {{interval}} päeva",
    "extraInfo": "Lisainfo",
    "extraInfoAboutTheProduct": "Lisainfo toote kohta...",
    "maintenanceHistory": "Hoolduste ajalugu",
    "maintenanceInfo": "Hoolduse info",
    "maintenanceInterval": "Hooldusintervall päevades",
    "maintenanceName": "Hoolduse nimi",
    "maintenanceOverview": {
      "addFileTooltip": "Kohustuslik",
      "date": "Hooldus tehtud",
      "document": "Failid",
      "scheduledDate": "Tähtaeg"
    },
    "maintenancePopup": {
      "addFile": "Lisa fail",
      "addFileTooltip": "Lisa fail",
      "done": "Tehtud",
      "maintenanceGuide": "Hoolduse juhend",
      "maintenanceInterval": "Hooldusintervall",
      "relatedProduct": "Seotud toode",
      "upcomingMaintenance": "Tulev hooldus"
    },
    "manufacturer": "Tootja",
    "name": "Toote nimi",
    "nextMaintenance": "Järgmine hooldus",
    "productNumber": "Tootenumber",
    "productSuccessfullyChanged": "Toode edukalt uuendatud",
    "relatedDocuments": "Seotud dokumendid",
    "relatedRooms": "Seotud toad",
    "saveChanges": "Salvesta muudatused"
  },
  "propertyManagerCase": {
    "addFiles": "Lisa failid",
    "afterSalesService": "Järelteenindus",
    "answer": "Vasta",
    "cancel": "Tühista",
    "caseActions": {
      "addReply": "Lisa vastus",
      "closeCase": "Sulge juhtum",
      "markAsSolved": "Märgi lahendatuks",
      "openCase": "Ava juhtum",
      "reopenCase": "Taasava juhtum"
    },
    "caseDescription": "Juhtumi kirjeldus",
    "caseDetails": {
      "address": "Aadress",
      "category": "Kategooria",
      "name": "Nimi",
      "phoneNumber": "Telefoninumber",
      "subcontractor": "Teenusepakkuja"
    },
    "caseStatus": {
      "backlog": "Halduri poolt ülevaatamisel",
      "closed": "Tagasi lükatud",
      "inProgress": "Töös",
      "notDone": "Avatud",
      "review": "Ülevaatamisel",
      "solved": "Lõpetatud",
      "status": "Staatus",
      "toDo": "Kooskõlastamisel",
      "waiting": "Ootel"
    },
    "caseTitle": "Juhtumi pealkiri",
    "cases": "Halduri juhtumid",
    "completedCases": "Suletud",
    "contactPersonsPhoneNumber": "Kontaktisiku telefoninumber",
    "defectDate": "Juhtumi ilmnemise kuupäev",
    "defectDescription": "Juhtumi võimalikult täpne kirjeldus",
    "defectLocation": "Juhtumi täpne asukoht hoones/korteris",
    "describeCase": "Kirjelda halduri juhtumit",
    "descriptionIsSufficient": "Kirjeldus on piisav",
    "downloadFile": "Laadi fail alla",
    "emailNotification": "Vastused teie sõnumitele saadetakse ka teie e-posti aadressile. Ärge unustage kontrollida ka oma rämpsposti kausta.",
    "forceSubmitCase": "Esita juhtum",
    "maintenanceOverview": {
      "addFileTooltip": "Vajalik",
      "date": "Hooldus Tehtud",
      "document": "Failid",
      "scheduledDate": "Tähtaeg"
    },
    "mandatoryFile": "Peale juhtumi täpsustamist AI-ga avaneb juhtumile kohustuslik faili lisamise võimalus",
    "noCases": "Teil ei ole ühtegi halduri juhtumit registreeritud",
    "noFilesUploaded": "Faili üleslaadimine on kohustuslik",
    "notCovered": "Arvatavasti ei lähe juhtum halduri alla",
    "ongoingCases": "Pooleliolevad",
    "owner": "Omanik",
    "pictureDescription": "Juhtumi kiiremaks menetlemiseks: palun lisa teavitusega kaasa kaks pilti, millest üks on lähemalt ning teine eemalt, et oleks näha mure asukoht.",
    "problemDescriptionInstructions": "Probleemi tuleks kirjeldada võimalikult täpselt:",
    "sendMessageToDeveloper": "Saada sõnum haldurile",
    "sendMessageToOwner": "Saada sõnum koduomanikele",
    "sendingCase": "Saadan juhtumi...",
    "startSubmission": "Alusta esitamist",
    "submitCase": "Esita juhtum",
    "submitNewCase": "Esita uus halduri juhtum",
    "submitOneCase": "Esita üks halduri juhtum korraga",
    "submittedCases": "Esitatud halduri juhtumid"
  },
  "question": {
    "ask_in_chat_hint": "Küsimused, mida küsite AI-assistendilt vestluse kaudu, kuvatakse siin.",
    "closedByService": "Küsimus on järelteeninduse poolt suletud",
    "details": {
      "address": "Aadress",
      "name": "Nimi"
    },
    "downloadFile": "Laadi fail alla",
    "emailNotification": "Vastused teie sõnumitele saadetakse ka teie e-posti aadressile. Ärge unustage kontrollida ka oma rämpsposti kausta.",
    "loading": "Laen küsimusi...",
    "markedAsSolved": "Küsimus on märgitud lahendatuks",
    "messageWithImage": "Sõnum pildiga",
    "no_questions_yet": "Sa ei ole veel ühtegi küsimust esitanud.",
    "notFound": "Küsimust ei leitud",
    "previousChatWithBot": "Eelnev vestlus juturobotiga",
    "questions": "Küsimused",
    "sendMessageToDeveloper": "Saada sõnum arendajale",
    "sendMessageToOwner": "Saada sõnum koduomanikele",
    "status": {
      "backlog": "Ülevaatamisel",
      "closed": "Suletud",
      "solved": "Lahendatud",
      "status": "Staatus"
    },
    "submittedQuestions": "Esitatud küsimused"
  },
  "room": {
    "add": "Lisa ruum",
    "addNew": "Lisa uus ruum",
    "change": "Muuda ruume",
    "delete": "Kustuta",
    "floor": "Korrus",
    "name": "Nimi",
    "newRoomName": "Uue ruumi nimi",
    "outdoor": "Õues",
    "rename": "Nimeta ümber",
    "save": "Salvesta"
  },
  "settings": {
    "accesses": "Ligipääsud",
    "accountAssignmentFailed": "Konto määramine ebaõnnestus.",
    "addNewAccess": "Lisa uus elanik",
    "companyFirstUserEmail": "Kasutaja e-post",
    "companyFirstUserName": "Kasutaja nimi",
    "companyName": "Ettevõtte nimi",
    "confirmUnassign": "Eemalda",
    "confirmUnassignMessage": "Kas oled kindel, et soovid eemaldada ligipääsu isikule {{name}}?",
    "confirmUnassignTitle": "Eemalda ligipääs",
    "currentWarrantyEndDate": "Praegune garantii lõppkuupäev",
    "email": "Email",
    "emailRequired": "E-post on kohustuslik",
    "householdSettings": "Korteri sätted",
    "individual": "Eraisik",
    "moreInfoRequired": "Vajalik lisainfo.",
    "name": "Nimi",
    "organization": "Ettevõte",
    "personName": "Isiku nimi",
    "registryCode": "Registrikood",
    "registryCodeRequired": "Registrikood on kohustuslik",
    "save": "Salvesta",
    "saveError": "Seadistuse salvestamine ebaõnnestus",
    "saveFailed": "Seadete salvestamine ebaõnnestus",
    "saveSuccess": "Seaded edukalt salvestatud",
    "saving": "Salvestamine...",
    "title": "Seadista ligipääs",
    "type": "Tüüp",
    "warrantyEndDate": "Garantii lõppkuupäev",
    "warrantyUpdateFailed": "Garantii kuupäeva uuendamine ebaõnnestus."
  },
  "structuredWarrantySettings": {
    "addCategory": "Lisa kategooria",
    "addSubcontractor": "Lisa alltöövõtja",
    "categories": "Garantiikategooriad",
    "categoryDescription": "Kirjeldus (AI kategooria valimiseks)",
    "categoryDescriptionPlaceholder": "Aitab AI-l õiget kategooriat valida. Nt küttega, radiaatorite, termostaatide või põrandaküttega seotud probleemid",
    "categoryDocs": "Dokumendid",
    "categoryName": "Kategooria nimi",
    "customPrompt": "Kohandatud juhis (valikuline)",
    "customPromptPlaceholder": "Juhendab AI-d selle kategooria garantiijuhtumi esitamisel. Nt küsi seadme mudelinumbrit ja ostukuupäeva",
    "defaultCategory": "Vaikekategooria",
    "defaultCategoryDescription": "Kirjeldus (valikuline)",
    "defaultCategoryName": "Nimi (valikuline)",
    "defaultDocs": "Vaikedokumendid",
    "defaultEmail": "Vaike-e-post",
    "enable": "Luba täiustatud garantiivoog",
    "hideDocuments": "Peida saadaolevad dokumendid",
    "noDocsSelected": "Dokumente pole valitud",
    "noDocuments": "Dokumente pole",
    "noMatchingDocuments": "Sobivaid dokumente ei leitud",
    "removeCategory": "Eemalda kategooria",
    "removeSubcontractor": "Eemalda alltöövõtja",
    "searchDocuments": "Otsi dokumente...",
    "showDocuments": "Näita saadaolevaid dokumente ({{count}})",
    "subcontractorEmail": "E-post",
    "subcontractorName": "Nimi",
    "subcontractors": "Alltöövõtjad"
  },
  "tallyFormSettings": {
    "addForm": "Lisa vorm",
    "bannerText": "Bänneri tekst (nt Võida 100 €, kui täidad vormi!)",
    "bannerTextPlaceholder": "Sisesta sõnum, mis innustab kasutajaid vormi täitma",
    "enable": "Luba Tally vormid",
    "errors": {
      "invalidLanguage": "Keel peab olema kahetäheline kood (nt \"en\"). Sisestasid: \"{{language}}\"",
      "invalidUrl": "Kasuta Tally.so vormi avalikku URL-i. Sisestasid: \"{{url}}\"",
      "urlEndsWithEdit": "URL ei tohi lõppeda \"/edit\"-iga. Sisesta vormi avalik URL."
    },
    "language": "Keel ISO 639-1 (nt en, et, lv)",
    "removeRule": "Eemalda reegel",
    "resetStatuses": "Lähtesta korterite staatused",
    "success": {
      "reset": "Korteri staatused edukalt lähtestatud",
      "saved": "Tally vormi sätted edukalt salvestatud"
    },
    "url": "Tally.so vormi URL (nt https://tally.so/r/xyz)"
  },
  "warranty": {
    "addFiles": "Lisa failid",
    "afterSalesService": "Järelteenindus",
    "answer": "Vasta",
    "cancel": "Tühista",
    "caseActions": {
      "addReply": "Lisa vastus",
      "closeCase": "Sulge juhtum",
      "markAsSolved": "Märgi lahendatuks",
      "openCase": "Ava juhtum",
      "reopenCase": "Taasava juhtum"
    },
    "caseDescription": "Juhtumi kirjeldus",
    "caseDetails": {
      "address": "Aadress",
      "category": "Kategooria",
      "name": "Nimi",
      "phoneNumber": "Telefoninumber",
      "subcontractor": "Teenusepakkuja"
    },
    "caseStatus": {
      "backlog": "Ehitaja poolt ülevaatamisel",
      "closed": "Tagasi lükatud",
      "inProgress": "Töös",
      "notDone": "Avatud",
      "review": "Ülevaatamisel",
      "solved": "Lõpetatud",
      "status": "Staatus",
      "toDo": "Kooskõlastamisel",
      "waiting": "Ootel"
    },
    "caseTitle": "Juhtumi pealkiri",
    "cases": "Garantiijuhtumid",
    "completedCases": "Suletud",
    "contactPersonsPhoneNumber": "Kontaktisiku telefoninumber",
    "defectDate": "Puuduse ilmnemise kuupäev",
    "defectDescription": "Puuduse võimalikult täpne kirjeldus",
    "defectLocation": "Puuduse täpne asukoht hoones/korteris",
    "describeCase": "Kirjelda garantiijuhtumit",
    "description": "Kirjeldus",
    "descriptionIsSufficient": "Kirjeldus on piisav",
    "developer": "Arendaja",
    "downloadFile": "Laadi fail alla",
    "emailNotification": "Vastused teie sõnumitele saadetakse ka teie e-posti aadressile. Ärge unustage kontrollida ka oma rämpsposti kausta.",
    "file": "Fail",
    "filesSelected": "faili valitud",
    "forceSubmitCase": "Esita juhtum",
    "likelyCovered": "See juhtum jääb arvatavasti garantii alla",
    "maintenanceOverview": {
      "addFileTooltip": "Vajalik",
      "date": "Hooldus Tehtud",
      "document": "Failid",
      "scheduledDate": "Tähtaeg"
    },
    "mandatoryFile": "Peale juhtumi täpsustamist AI-ga avaneb juhtumile kohustuslik faili lisamise võimalus",
    "mayNotBeCovered": "See juhtum ei pruugi garantii alla jääda",
    "noCases": "Teil ei ole ühtegi garantiijuhtumi registreeritud",
    "noFilesUploaded": "Fail (foto/video) on kohustuslik",
    "notCovered": "Arvatavasti ei lähe juhtum garantiipuuduse alla",
    "ongoingCases": "Pooleliolevad",
    "owner": "Omanik",
    "phoneNumberPlaceholder": "+372 5555 5555",
    "pictureDescription": "Juhtumi kiiremeks menetlemiseks: palun lisa teavitusega kaasa kaks pilti, millest üks on lähemalt ning teine eemalt, et oleks näha mure asukoht.",
    "problemDescriptionInstructions": "Probleemi tuleks kirjeldada võimalikult täpselt:",
    "sendMessageToDeveloper": "Saada sõnum arendajale",
    "sendMessageToOwner": "Saada sõnum koduomanikele",
    "sendingCase": "Saadan juhtumi...",
    "startSubmission": "Alusta esitamist",
    "subcontractor": "Teenusepakkuja",
    "submissionDisabled": "Garantiimurede esitamine ei ole veel ehitaja süsteemiga ühendatud. See on ajutine. Palume mõne päeva pärast uuesti kontrollida. Kiireloomuliste murede korral palun saatke e-kiri aadressile info@dobu.app",
    "submitCase": "Esita juhtum",
    "submitClaim": "Esita taotlus",
    "submitNewCase": "Esita uus garantiijuhtum",
    "submitOneCase": "Esita üks garantiijuhtum korraga",
    "submittedCases": "Esitatud garantiijuhtumid",
    "voiceAgent": {
      "callInProgress": "Kõne käib",
      "callWarrantyAgent": "Helista garantiiagendile",
      "connecting": "Ühendamine..."
    },
    "warrantyIsValidUntil": "Garantii kehtib kuni {{date}}",
    "warrantyPeriodHasExpired": "Garantiiaeg on lõppenud"
  },
  "warrantyInspection": {
    "defects": "Selle ülevaatuse puudused",
    "needsAttention_one": "{{count}} vajab tähelepanu",
    "needsAttention_other": "{{count}} vajavad tähelepanu",
    "progress": "{{done}}/{{total}} lõpetatud",
    "title": "Garantiiaja lõppülevaatus"
  },
  "warrantyIntake": {
    "builderNoteTitle": "Ehitaja garantiitingimustest:",
    "nextIssue": "Järgmine sinu loetelust (jäänud {{count}}). Täienda soovi korral ja alusta esitamist.",
    "otherIssuesHint": "Igaühest saab eraldi juhtum. Pärast selle esitamist jätkame järgmisega.",
    "otherIssuesTitle": "Mainisid veel:",
    "selfCheckHint": "Kui see ei aita, esita juhtum allpool.",
    "selfCheckTitle": "Enne esitamist võid kodu juhenditest proovida:",
    "skipIssue": "Jäta see vahele",
    "submitted": "Juhtum esitatud.",
    "tipOneMessage": "Kirjuta ühe sõnumiga, mis on valesti, kus see asub ja umbes millal seda märkasid. Nii on juhtum kohe valmis.",
    "tipSeveral": "Mitu muret? Pane need kõik korraga kirja. Igaühest saab eraldi juhtum, üksteise järel ja ilma uuesti kirjutamata."
  }
}
